import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";

import {
    DropzoneComponent, DropzoneDirective,
    DropzoneConfigInterface
} from 'ngx-dropzone-wrapper';

import { ModalComponent } from '../modal';

@Component({
    selector: 'app-image-list-modal',
    templateUrl: './image-list-modal.component.html',
    styleUrls: ['./image-list-modal.component.scss']
})

export class ImageListModalComponent {
    private fileIndex: number = 0;
    private currentFile: any;
    messages = {
        emptyMessage: 'Sin fotos',
        totalMessage: ''
    };
    @Output() deleted = new EventEmitter();
    @ViewChild(ModalComponent) modal: ModalComponent;
    @Input() canDelete = true;
    @Input() data = [];
    constructor() { }

    deleteFile(file) {
        this.data.splice(file['index'], 1);
        this.files = this.data;
        this.deleted.emit(file);
    }
    viewFile(file) {
        this.currentFile = file;
        this.showModal();
    }
    get files() {
        return this.data;
    }
    set files(data) {
        this.data = data.map((element, index) => {
            element['index'] = index;
            return element;
        });
    }
    showModal() {
        this.modal.show();
    }
    private prev(event: any) {
        this.fileIndex--;
        if (this.fileIndex < 0) {
            this.fileIndex = this.files.length - 1;
        }
        this.viewFile(this.files[this.fileIndex]);
        event.stopPropagation();
    }
    private next(event: any) {
        this.fileIndex++;
        if (this.fileIndex >= this.files.length) {
            this.fileIndex = 0;
        }
        this.viewFile(this.files[this.fileIndex]);
        event.stopPropagation();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/image-list-modal/image-list-modal.component.ts